// extracted by mini-css-extract-plugin
export var banner = "style-module--banner--2hLsC";
export var image = "style-module--image--23uEW";
export var title = "style-module--title--1Hi6p";
export var content = "style-module--content--3OfXd";
export var item = "style-module--item--2V3dX";
export var itemImage = "style-module--itemImage--2eJd4";
export var itemTitle = "style-module--itemTitle--1Ty4k";
export var itemDescr = "style-module--itemDescr--3SXr8";